import { css } from 'aphrodite';
import { Control, FormState } from 'react-hook-form';
import { FormFieldType } from '../../../../../extViewmodels';
import { IFormField } from '../../../../models/Api';
import { IFormValues } from '../utils';
import { CheckboxInput, SelectInput, StringInput } from './CustomFormInputs';
import { styleSheet } from './styles';

interface IProps {
	field: IFormField<string>;
	control: Control<IFormValues>;
	formState: FormState<IFormValues>;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
}

export const CustomFormFieldRenderer = ({ field, control, formState, setValue }: IProps) => {
	const renderInput = () => {
		switch (field.fieldType) {
			case FormFieldType.String:
				return <StringInput field={field} control={control} formState={formState} />;

			case FormFieldType.Option:
				return <SelectInput field={field} control={control} formState={formState} setValue={setValue} />;

			case FormFieldType.MultipleOptions:
				return <CheckboxInput field={field} control={control} formState={formState} setValue={setValue} />;

			default:
				return null;
		}
	};

	return (
		<div className={css(styleSheet.formControl)}>
			<label htmlFor={field.id} className={css(styleSheet.label)}>
				{field.label}
				{!field.isOptional ? (
					<>
						{' '}
						<span className={css(styleSheet.required)}>*</span>
					</>
				) : null}
			</label>
			{renderInput()}
		</div>
	);
};
